import { useSelector } from 'react-redux';
import type { RootState } from '../../../store/models';
import type { StoredDiscountInfo } from '../../../store/NCDAndDiscountedPros.types';

export default function useNCDAndDiscountInfo(providerId): StoredDiscountInfo {
  return useSelector((state: RootState) => (
    state.ncdAndDiscountedPros.providers[providerId]
  ));
}
